import { CIRCLES } from "@/mocks/gossip";

const ICONS = ["ri-team-line", "ri-user-heart-line", "ri-mic-2-line", "ri-live-line"];

export default function Circles() {
  return (
    <section id="circles" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-700 uppercase">
            <i className="ri-share-2-line" aria-hidden="true"></i>
            Ecosystem
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">国产吃瓜圈子生态图谱</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            每个名场面都诞生于一个具体圈子。我们把当下最活跃的四个娱乐圈层拆给你看：谁在制造现场、谁在放大传播、名场面又从哪里来。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {CIRCLES.map((c, i) => (
            <article
              key={c.name}
              className="relative flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-accent-300"
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                <i className={`${ICONS[i]} text-2xl`} aria-hidden="true"></i>
              </div>
              <span className="absolute right-5 top-5 font-heading text-4xl font-black text-background-200">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1 text-xs font-semibold tracking-wide text-accent-700">{c.role}</p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{c.desc}</p>
              <span className="mt-5 inline-flex w-fit items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 whitespace-nowrap">
                <i className="ri-database-2-line text-secondary-700" aria-hidden="true"></i>
                {c.count}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}